module.exports = __webpack_public_path__ + "static/media/elsa-jean-icon.a00f2e60.jpg";